import { connect } from 'react-redux';
import React from 'react';import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import SoftwareProducts from './softwareProducts/components/Products';
import HardwareProducts from './hardwareProducts/components/Products';
import { customer, ui } from '../../../modules';
import Box from '../profilePage/components/Box';
import BoxesRow from '../profilePage/components/BoxesRow';
import ActionButton from '../../components/ActionButton';

class Products extends React.Component {

    getButtons = () => [
        <ActionButton icon="user" to={this.props.getUrl('serials')} title="Serienumre" icon="key" />,
        <ActionButton icon="user" to={'/#/customer/' + this.props.customerId + '/order'} title="Legg til produkter" icon="plus" />,
        <ActionButton icon="link" to={'/#/customer/' + this.props.customerId + '/hardwareproducts/addhardware'} title="Registrer utstyr" />
    ];

    render = () => <BoxesRow>
        <Box label="Abonnement og utstyr" buttons={this.getButtons()}>
            <SoftwareProducts />
            <HardwareProducts />
        </Box>
    </BoxesRow>
}

const mapStateToProps = (state, props) => ({
    customerId: customer.profile.selectors.getCustomerID(state),
    getUrl: (page) => ui.selectors.getUrl(state, page)
});

export default connect(mapStateToProps)(Products);


